var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{ref:"iframe",attrs:{"id":"bdIframe","src":_vm.bdTokenUrl,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }